import { dataReportTrendSettings } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportTrendSettings = /*#__PURE__*/createIcon(dataReportTrendSettings)
export default IconReportTrendSettings
